import React, { useEffect, useRef, useState } from "react";
import { Flex, Form, Spin } from "antd";
import { IoMdSend } from "react-icons/io";
import {
  countUnreadMessagesByDoctor,
  listenForMessages,
  sendMessage,
  listenForPatientsList,
  markMessagesAsSeen,
  countUnreadMessages,
} from "../../../Services/chatService";
import userIcon from "../../../Assets/Images/Svg/doctorIcon.svg";
import dayjs from "dayjs";
import { IoArrowBack, IoChevronBackOutline } from "react-icons/io5";
import PatientService from "../../../Services/PatientService";
import { FaUser } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { DECREASECOUNT } from "../../../Redux/actions/ChatActions.js";
import { CiCirclePlus } from "react-icons/ci";
import { ImAttachment } from "react-icons/im";
import relativeTime from "dayjs/plugin/relativeTime";
import calendar from "dayjs/plugin/calendar";
import backArrow from "../../../Assets/Images/Svg/backArrow.svg";
import threeDotIcon from "../../../Assets/Images/Svg/three_dot_icon.svg";
dayjs.extend(relativeTime);
dayjs.extend(calendar);

function LiveChat({ handleClose, chatOpen }) {
  const [patientList, setPatientList] = useState([]);
  const [messages, setMessages] = useState([]);
  const [chatScreenEnable, setChatScreenEnable] = useState(false);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [conversedPatIds, setConversedPatIds] = useState([]);
  const [conversedPatList, setConversedPatList] = useState([]);
  const [unreadCounts, setUnreadCounts] = useState({});
  const [filteredPatients, setFilteredPatients] = useState([]);
  const [allPatView, setAllPatView] = useState(false);
  const [enterBtnClicked, setEnterBtnClicked] = useState(false);
  const loggedUserObj = localStorage.getItem("login_result");
  const loggedUser = loggedUserObj ? JSON.parse(loggedUserObj) : null;
  const unsubscribeRef = useRef(null);
  const chatContainerRef = useRef(null);
  const dispatch = useDispatch();
  const totalnotifyCount = useSelector((state) => state.chatCount.count);
  const msgRef = useRef();

  useEffect(() => {
    // fetching all available doctors with we can chat!
    const fetchAllPat = async () => {
      const payload = {
        account_Id: loggedUser.user.account_Id,
        clinic_Id: loggedUser.user.clinic_Id,
        createdBy: loggedUser.user.userId,
      };
      const response = await getPatientList(payload);
      setPatientList(response);
    };
    fetchAllPat();
    const unsubscribe = listenForPatientsList(
      loggedUser.user.userId,
      setConversedPatIds
    );

    return () => unsubscribe(); // Cleanup listener
  }, []);

  useEffect(() => {
    if (filteredPatients.length > 0 && conversedPatIds.length > 0) {
      const filtered = filteredPatients.filter((doc) =>
        conversedPatIds.includes(doc.patientId)
      );
      setConversedPatList(filtered);
    }
  }, [conversedPatIds, filteredPatients]);

  useEffect(() => {
    const fetchAllConvPat = async () => {
      const patArr = [];
      for (let patId of conversedPatIds) {
        const patRes = await getPatientList({ patientId: patId });
        patArr.push(patRes[0]);
      }
      setFilteredPatients(patArr);
    };

    fetchAllConvPat();
  }, [conversedPatIds]);

  useEffect(() => {
    return () => {
      if (unsubscribeRef.current) {
        unsubscribeRef.current();
      }
    };
  }, []);

  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop =
        chatContainerRef.current.scrollHeight;
    }
  }, [messages]);

  useEffect(() => {
    fetchUnreadCounts();
  }, [loggedUser.user.userId]);

  async function fetchUnreadCounts() {
    const counts = await countUnreadMessagesByDoctor(loggedUser.user.userId);
    setUnreadCounts(counts);
  }

  const getPatientList = async (filterPayload) => {
    const payload = {
      ...filterPayload,
      status: 1,
    };
    setIsLoading(true);
    try {
      const response = await PatientService.PatientListFilter(payload);
      // setPatientList(response.data);
      setIsLoading(false);
      return response.data;
    } catch (e) {
      console.error(e);
      setIsLoading(false);
    }
  };
  useEffect(() => {
    if (localStorage.getItem("qChat")) {
      let chatFromQ = JSON.parse(localStorage.getItem("qChat"));
      handleSelectChat(chatFromQ);
      localStorage.removeItem("qChat");
    }
  }, [localStorage.getItem("qChat")]);

  const handleSelectChat = async (doc) => {
    setSelectedPatient(doc);
    setMessages([]);
    if (unsubscribeRef.current) {
      unsubscribeRef.current();
    }
    markMessagesAsSeen(loggedUser.user.userId, doc.patientId);
    // const msgCount = await countUnreadMessages(loggedUser.user.userId);
    const counts = await countUnreadMessagesByDoctor(loggedUser.user.userId);
    let totalUnreadCount = 0;
    for (let key in counts) {
      totalUnreadCount += counts[key];
    }
    dispatch({ type: DECREASECOUNT, payload: totalUnreadCount });
    unsubscribeRef.current = listenForMessages(
      doc.patientId,
      loggedUser.user.userId,
      setMessages
    );
    setAllPatView(false);
    setChatScreenEnable(true);
  };

  const handleBack = async () => {
    markMessagesAsSeen(loggedUser.user.userId, selectedPatient.patientId);
    // const msgCount = countUnreadMessages(loggedUser.user.userId);
    // dispatch({ type: DECREASECOUNT, payload: Number(totalnotifyCount) - Number(msgCount) });
    const counts = await countUnreadMessagesByDoctor(loggedUser.user.userId);
    let totalUnreadCount = 0;
    for (let key in counts) {
      totalUnreadCount += counts[key];
    }
    dispatch({ type: DECREASECOUNT, payload: totalUnreadCount });
    await fetchUnreadCounts();
    setChatScreenEnable(false);
    setSelectedPatient(null);
  };

  const handleSend = async () => {
    if (message.trim()) {
      try {
        await sendMessage(
          loggedUser.user.userId,
          selectedPatient.patientId,
          message
        );
        msgRef.current.resetFields();
        setMessage("");
        setEnterBtnClicked(false);
        listenForMessages(
          selectedPatient.patientId,
          loggedUser.user.userId,
          setMessages
        );
      } catch (error) {
        console.error("Error sending message:", error);
      }
    }
  };

  const handleMsgSend = (event) => {
    if (event.key === "Enter" && !enterBtnClicked) {
      setEnterBtnClicked(true);
      handleSend();
    }
  };

  const handleAllPatListView = () => {
    setAllPatView(!allPatView);
  };

  const handleContBack = () => {
    setAllPatView(false);
  };

  const handlePatFilter = () => {};

  return (
    <div>
      {!chatScreenEnable && !allPatView && (
        <div className="w-full max-w-sm mx-auto bg-white shadow-lg rounded-lg">
          <div className="flex items-center p-4 border-b">
            <button
              className="text-gray-500 bg-white"
              onClick={handleAllPatListView}
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16m-7 6h7"
                ></path>
              </svg>
            </button>
            <input
              type="text"
              placeholder="Search"
              className="ml-4 flex-1 px-4 py-2 rounded-full bg-gray-100 outline-none"
            />
          </div>

          <div className="">
            {isLoading && conversedPatList.length === 0 ? (
              <div className="h-screen flex items-center justify-center">
                <Flex align="center" gap="middle">
                  <Spin size="large" tip="Loading" />
                </Flex>
              </div>
            ) : !isLoading && conversedPatList.length === 0 ? (
              <div className="h-screen flex flex-col gap-1 justify-center items-center">
                <p className="text-lg font-light">No conversations.</p>
                {/* <button
                  className="flex items-center gap-1 rounded-lg p-1.5 bg-primaryColor text-white"
                  onClick={handleAllPatListView}
                >
                  <CiCirclePlus className="text-lg" />
                  <span className="font-medium">New Chat</span>
                </button> */}
              </div>
            ) : (
              conversedPatList.map((pat, index) => (
                <div
                  key={index}
                  className="flex items-center border-b p-2 hover:bg-gray-100 cursor-pointer"
                  onClick={() => handleSelectChat(pat)}
                >
                  {pat.photoName ? (
                    <img
                      src={process.env.REACT_APP_IMAGE_URL + pat.photoName}
                      alt={pat?.firstName}
                      className="w-12 h-12 rounded-full"
                    />
                  ) : (
                    // <img
                    //     src={userIcon}
                    //     alt={pat?.firstName}
                    //     className="w-12 h-12 rounded-full"
                    // />
                    <FaUser className="w-12 h-12 rounded-full text-blue-200" />
                  )}
                  <div className="ml-4 flex-1">
                    <div className="flex justify-between items-center">
                      <h3 className="font-semibold flex items-center">
                        {pat?.firstName}
                      </h3>
                      <>
                        {unreadCounts[pat?.patientId] > 0 && (
                          <span className="min-w-5 max-w-max w-5 h-5 rounded-[50%] bg-brand-colorError text-white text-center">
                            {unreadCounts[pat?.patientId]}
                          </span>
                        )}
                      </>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      )}

      {selectedPatient && chatScreenEnable && !allPatView && (
        <div className="flex flex-col h-screen border rounded-md">
          <div className="bg-[#FFFFFF] text-[#333333] h-14 px-1 py-1.5  flex justify-between items-center">
            <div className="h-[inherit] flex items-center gap-3">
              {/* <IoChevronBackOutline
              className="font-medium text-xl text-[#333333] mx-2 cursor-pointer"
              onClick={handleBack}
            /> */}
              <img
                src={backArrow}
                className="font-medium text-xl text-[#333333] mx-2 cursor-pointer"
                alt="Back Arrow"
                onClick={handleBack}
              />
              <div className="w-10 h-10 rounded-full flex items-center">
                {selectedPatient.photoName ? (
                  <img
                    src={
                      process.env.REACT_APP_IMAGE_URL +
                      selectedPatient.photoName
                    }
                    alt={selectedPatient?.firstName}
                    className="w-10 h-10 rounded-full"
                  />
                ) : (
                  // <img
                  //     src={userIcon}
                  //     alt={selectedPatient?.firstName}
                  //     className="w-10 h-10 rounded-full"
                  // />
                  <FaUser className="w-10 h-10 rounded-full text-blue-200" />
                )}
              </div>
              <div className="pt-4">
                <p className="font-medium text-base font-roboto">
                  {selectedPatient?.firstName}
                </p>
              </div>
            </div>
            <img
              src={threeDotIcon}
              className="font-medium text-xl text-[#333333] mx-2 cursor-pointer"
              alt="Three dots"
            />
          </div>

          {/* <div ref={chatContainerRef} className="h-[85%] hideScrollBar px-2 bg-[#F0F2F1]">
            {messages &&
              messages
                ?.sort(
                  (a, b) => a.timestamp?.toMillis() - b.timestamp?.toMillis()
                )
                .map((msg) => (
                  <div className="w-full flex items-center justify-between">
                    {msg.senderID === loggedUser.user.userId ? (
                      <div
                        key={msg.id}
                        className="max-w-64 my-0.5 relative p-1 text-slate-800 bg-[#CDEBEA] border rounded-l-lg rounded-br-lg ml-auto"
                      >
                        {msg.text}
                        <div className="flex justify-end">
                          <span className="text-[8px]">
                            {dayjs(msg.timestamp?.toDate()).format("hh:mm A")}
                          </span>
                        </div>
                        <svg
                          className="absolute top-0 right-0 translate-x-2 translate-y-0"
                          width="8"
                          height="13"
                          viewBox="0 0 8 13"
                          preserveAspectRatio="xMidYMid meet"
                        >
                          <path
                            opacity="0.13"
                            fill="#000000"
                            d="M6.467,3.568L0,12.193V1h5.188C6.958,1,7.526,2.156,6.467,3.568z"
                          ></path>
                          <path
                            fill="#c0e9e9"
                            d="M6.467,2.568L0,11.193V0h5.188C6.958,0,7.526,1.156,6.467,2.568z"
                          ></path>
                        </svg>
                      </div>
                    ) : (
                      <div
                        key={msg.id}
                        className="max-w-64 my-0.5 relative p-1 text-slate-800 bg-[#FFFFFF] border rounded-r-lg rounded-bl-lg mr-auto"
                      >
                        {msg.text}
                        <div className="flex justify-end">
                          <span className="text-[8px]">
                            {dayjs(msg.timestamp?.toDate()).format("hh:mm A")}
                          </span>
                        </div>
                        <svg
                          className="absolute top-0 left-0 -translate-x-2 translate-y-0"
                          width="8"
                          height="13"
                          viewBox="0 0 8 13"
                          preserveAspectRatio="xMidYMid meet"
                        >
                          <path
                            opacity="0.13"
                            fill="#000000"
                            d="M1.533,3.568L8,12.193V1H2.812 C1.042,1,0.474,2.156,1.533,3.568z"
                          ></path>
                          <path
                            fill="#e5e2e2"
                            d="M1.533,2.568L8,11.193V0L2.812,0C1.042,0,0.474,1.156,1.533,2.568z"
                          ></path>
                        </svg>
                      </div>
                    )}
                  </div>
                ))}
          </div> */}
          <div
            ref={chatContainerRef}
            className="h-[85%] hideScrollBar px-2 bg-[#F0F2F1]"
          >
            {messages &&
              messages
                ?.sort(
                  (a, b) => a.timestamp?.toMillis() - b.timestamp?.toMillis()
                )
                .reduce((acc, msg, index, arr) => {
                  const messageDate = dayjs(msg.timestamp?.toDate()).format(
                    "DD/MM/YYYY"
                  );
                  const prevMessageDate =
                    index > 0
                      ? dayjs(arr[index - 1].timestamp?.toDate()).format(
                          "DD/MM/YYYY"
                        )
                      : null;

                  // Add date separator if it's a new date
                  if (messageDate !== prevMessageDate) {
                    acc.push(
                      <div
                        key={`date-${messageDate}`}
                        className="text-center text-xs text-gray-500 my-2"
                      >
                        {dayjs(msg.timestamp?.toDate()).calendar(null, {
                          sameDay: "[Today]",
                          lastDay: "[Yesterday]",
                          lastWeek: "dddd",
                          sameElse: "DD/MM/YYYY",
                        })}
                      </div>
                    );
                  }

                  acc.push(
                    <div
                      key={msg.id}
                      className="w-full flex items-center justify-between"
                    >
                      {msg.senderID === loggedUser.user.userId ? (
                        <div className="max-w-64 my-0.5 relative p-1 text-slate-800 bg-[#CDEBEA] border rounded-l-lg rounded-br-lg ml-auto">
                          {msg.text}
                          <div className="flex justify-end">
                            <span className="text-[8px]">
                              {dayjs(msg.timestamp?.toDate()).format("hh:mm A")}
                            </span>
                          </div>
                        </div>
                      ) : (
                        <div className="max-w-64 my-0.5 relative p-1 text-slate-800 bg-[#FFFFFF] border rounded-r-lg rounded-bl-lg mr-auto">
                          {msg.text}
                          <div className="flex justify-end">
                            <span className="text-[8px]">
                              {dayjs(msg.timestamp?.toDate()).format("hh:mm A")}
                            </span>
                          </div>
                        </div>
                      )}
                    </div>
                  );

                  return acc;
                }, [])}
          </div>

          <Form ref={msgRef}>
            <div className="w-full flex items-center gap-2 p-2">
              <div className="w-[90%] chatText">
                <Form.Item name="textMsg">
                  <input
                    type="text"
                    className="border rounded-3xl outline-none w-full py-2 text-xs px-2 font-medium"
                    placeholder="Type message..."
                    onChange={(e) => setMessage(e.target.value)}
                    onKeyDown={handleMsgSend}
                  />
                </Form.Item>
              </div>
              {message && message.length > 0 ? (
                <div className="w-[10%]">
                  <div
                    onClick={handleSend}
                    className="w-7 h-7 rounded-full bg-brand-primaryColor flex items-center justify-center cursor-pointer"
                  >
                    <IoMdSend className="w-5 h-5 text-white" />
                  </div>
                </div>
              ) : (
                <div className="w-[10%]">
                  <div className="w-7 h-7 rounded-full bg-brand-primaryColor flex items-center justify-center cursor-pointer">
                    <ImAttachment className="w-5 h-5 text-white rotate-45" />
                  </div>
                </div>
              )}
            </div>
          </Form>
        </div>
      )}

      {allPatView && patientList.length > 0 && (
        <>
          <div className="flex gap-1 items-center p-4 border-b">
            <IoArrowBack
              className="font-medium w-6 h-6 text-iconBlue mx-2 cursor-pointer"
              onClick={handleContBack}
            />
            <input
              type="text"
              placeholder="Search"
              className="flex-1 px-4 py-2 rounded-full bg-gray-100 outline-none"
              onChange={handlePatFilter}
            />
          </div>
          <div className="">
            {isLoading && patientList.length === 0 ? (
              <div className="h-screen flex items-center justify-center">
                <Flex align="center" gap="middle">
                  <Spin size="large" tip="Loading" />
                </Flex>
              </div>
            ) : (
              patientList.map((pat, index) => (
                <div
                  key={index}
                  className="flex items-center border-b p-2 hover:bg-gray-100 cursor-pointer"
                  onClick={() => handleSelectChat(pat)}
                >
                  {pat.photoName ? (
                    <img
                      src={process.env.REACT_APP_IMAGE_URL + pat.photoName}
                      alt={pat?.firstName}
                      className="w-12 h-12 rounded-full"
                    />
                  ) : (
                    // <img
                    //     src={userIcon}
                    //     alt={pat?.firstName}
                    //     className="w-12 h-12 rounded-full"
                    // />
                    <FaUser className="w-12 h-12 rounded-full text-blue-200" />
                  )}
                  <div className="ml-4 flex-1">
                    <div className="flex justify-between items-center">
                      <h3 className="font-semibold flex items-center">
                        {pat?.firstName}
                      </h3>
                      <>
                        {unreadCounts[pat?.patientId] > 0 && (
                          <span className="min-w-5 max-w-max w-5 h-5 rounded-[50%] bg-brand-colorError text-white text-center">
                            {unreadCounts[pat?.patientId]}
                          </span>
                        )}
                      </>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </>
      )}
    </div>
  );
}

export default LiveChat;
